import { Tabs, TabsProps } from "antd";
import { isAdminOrSuperAdmin } from "utility/helper";
import { GlobalSettings } from "domains/settings/components/GlobalSettings";
import { PersonalSettings } from "domains/settings/components/PersonalSettings";

export const SettingsPage: React.FC = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Personliga inställningar",
      children: <PersonalSettings />,
    },
    ...(isAdminOrSuperAdmin()
      ? [
          {
            key: "2",
            label: "Globala inställningar",
            children: <GlobalSettings />,
          },
        ]
      : []),
  ];

  return <Tabs defaultActiveKey="1" type="card" items={items} />;
};
